import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
      projectList: JSON.parse(sessionStorage.getItem("projectList")),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo"))
    },
    mutations: {
      getProjectList: (state, value) => {
        sessionStorage.setItem('projectList', JSON.stringify(value))
        state.projectList = value
      },
      getUserInfo: (state, value) => {
        sessionStorage.setItem('userInfo', JSON.stringify(value))
        state.userInfo = value
      }
    }
  })
  
  export default store


// WEBPACK FOOTER //
// ./src/store.js